/*
 * Copyright (c) 2023-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import adobeIconSvg from '../img/socialIcons/adobe.svg';
import amazonIconSvg from '../img/socialIcons/amazon.svg';
import appleIconSvg from '../img/socialIcons/apple.svg';
import discordIconSvg from '../img/socialIcons/discord.svg';
import facebookIconSvg from '../img/socialIcons/facebook.svg';
import githubIconSvg from '../img/socialIcons/github.svg';
import gitlabIconSvg from '../img/socialIcons/gitlab.svg';
import googleIconSvg from '../img/socialIcons/google.svg';
import lineIconSvg from '../img/socialIcons/line.svg';
import linkedinIconSvg from '../img/socialIcons/linkedin.svg';
import msIconSvg from '../img/socialIcons/ms.svg';
import orcidIconSvg from '../img/socialIcons/orcid.svg';
import paypalIconSvg from '../img/socialIcons/paypal.svg';
import quickbooksIconSvg from '../img/socialIcons/quickbooks.svg';
import salesforceIconSvg from '../img/socialIcons/salesforce.svg';
import spotifyIconSvg from '../img/socialIcons/spotify.svg';
import xeroIconSvg from '../img/socialIcons/xero.svg';
import yahooIconSvg from '../img/socialIcons/yahoo.svg';
import yahooJapanIconSvg from '../img/socialIcons/yahoo-japan.svg';

export const idpIconMap: Record<string, string> = {
  apple: appleIconSvg,
  facebook: facebookIconSvg,
  google: googleIconSvg,
  linkedin: linkedinIconSvg,
  microsoft: msIconSvg,
  github: githubIconSvg,
  gitlab: gitlabIconSvg,
  yahoo: yahooIconSvg,
  line: lineIconSvg,
  paypal: paypalIconSvg,
  paypal_sandbox: paypalIconSvg,
  salesforce: salesforceIconSvg,
  amazon: amazonIconSvg,
  yahoojp: yahooJapanIconSvg,
  discord: discordIconSvg,
  adobe: adobeIconSvg,
  orcid: orcidIconSvg,
  spotify: spotifyIconSvg,
  xero: xeroIconSvg,
  quickbooks: quickbooksIconSvg,
};
